import {
    CoreEnv,
    CoreFooterLinks,
    CoreRequest,
    CoreUser,
} from '@eventbrite/context-gen';
import { useFeatureFlags } from '@eventbrite/feature-flag-utils';
import { RenderGlobalNavOrUndefined } from '@eventbrite/global-nav';
import { SiteStructure } from '@eventbrite/site-structure';
import React from 'react';
import { PageLayoutPreview } from './';

interface Props {
    preview?: boolean;
    env: CoreEnv;
    request: CoreRequest;
    user: CoreUser;
    footerLinks: CoreFooterLinks;
}

export const PageLayout: React.FC<Props> = ({
    children,
    preview,
    env,
    request,
    user,
    footerLinks,
}) => {
    const { enableIaGlobalNav } = useFeatureFlags();
    if (preview) {
        return <PageLayoutPreview>{children}</PageLayoutPreview>;
    }
    return (
        <SiteStructure
            env={env}
            request={request}
            user={user}
            globalHeader={RenderGlobalNavOrUndefined({
                config: { user: user, env: env },
                featureFlag: enableIaGlobalNav,
            })}
            footerLinks={footerLinks}
            fullScreenMain={true}
            showMarketingLinks={true}
            mainBackgroundColor="eds-bg-color--ui-100"
        >
            {children}
        </SiteStructure>
    );
};
